module.exports = __webpack_public_path__ + "img/silianhuodong_icon.88ed44a0.png";